import { useState } from "react"
import { Link } from "react-router"
import { Form, FormikProps } from "formik"

import ContentCard from "../../../components/ContentCard"
import ErrorCard from "../../../components/ErrorCard"
import { SubmitButton } from "../../../components/SubmitButton"
import { WrappedInput } from "../../../components/Input"
import { BirddogSignupDataTypes } from "../types/auth"

interface BirddogSignupFormComponentProps
  extends FormikProps<BirddogSignupDataTypes> {
  errorMessage: string | null
}

const ROLE_OPTIONS = [
  { value: "", label: "Select your role", disabled: true },
  { value: "forester", label: "Forester" },
  { value: "timber_buyer", label: "Timber Buyer" },
]

const BirddogSignupFormComponent = ({
  isSubmitting,
  errorMessage,
}: BirddogSignupFormComponentProps) => {
  const [showPassword, setShowPassword] = useState(false)

  const toggleShowPassword = () => {
    setShowPassword(!showPassword)
  }

  return (
    <ContentCard>
      <h3 className="text-center text-lg leading-[1.50] tracking-[0.02em] mb-2">
        Join BirdDog
      </h3>

      <Form className="space-y-4">
        {errorMessage && <ErrorCard>{errorMessage}</ErrorCard>}

        <div className="space-y-4">
          <div>
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-1">
                <WrappedInput
                  data-test="input-first-name"
                  label="First name"
                  name="first_name"
                  placeholder="First name"
                  type="text"
                />
              </div>

              <div className="space-y-1">
                <WrappedInput
                  data-test="input-last-name"
                  label="Last name"
                  name="last_name"
                  placeholder="Last name"
                  type="text"
                />
              </div>
            </div>
          </div>

          <div className="space-y-1">
            <WrappedInput
              data-test="input-email"
              label="Email address"
              name="email"
              placeholder="name@example.com"
              type="text"
              as="email"
            />
          </div>

          <div className="space-y-1">
            <WrappedInput
              data-test="input-password"
              label="Password"
              name="password"
              placeholder="Password"
              type={showPassword ? "text" : "password"}
              as="password"
              toggleShowPassword={toggleShowPassword}
              instructions="Password must have at least 8 characters."
            />
          </div>

          <div className="space-y-1">
            <WrappedInput
              data-test="input-company-name"
              label="Company name"
              name="company_name"
              placeholder="Your company name"
              type="text"
            />
          </div>

          <div className="space-y-1">
            <WrappedInput
              data-test="input-role"
              label="Role"
              name="role"
              as="select"
              options={ROLE_OPTIONS}
            />
          </div>

          <div>
            <SubmitButton
              className="btn2 btn2-primary btn2-block font-semibold mt-6"
              isSubmitting={isSubmitting}
              data-test="birddog-sign-up"
            >
              Create BirdDog Account
            </SubmitButton>
          </div>

          <div className="text-center">
            <Link to="/birddog/login" className="link--underline-only">
              Already have an account? <span className="link">Sign in</span>
            </Link>
          </div>
        </div>
      </Form>
    </ContentCard>
  )
}

export default BirddogSignupFormComponent
